export class PatternUtil {
  static email = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  static password = /^(?!(.)\1{4,}$)(.+)/;
  static phone = /^\+?\d+$/;
  static decimalNumber = /^\d+\.?\d{0,2}/;
}
